(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('CallNeedingNkCtrl', CallNeedingNkCtrl);

    CallNeedingNkCtrl.$inject = [
        '$uibModal', 'Print'
    ];

    function CallNeedingNkCtrl(
        $uibModal, Print
    ) {
        var vm = this;

        vm.addNumber = addNumber;
        vm.delNumber = delNumber;
        vm.initPage = initPage;
        vm.isCollapsed = true;
        vm.data = {
            number: [{number: null, quantity: null, comment: null}],
            date: new Date(),
            id: null,
            name: null,
            zip: null,
            city: null,
            address: null,
            email: null,
        };
        // vm.data = {
        //     number: [
        //         {number: 'AF', quantity: 1, comment: 'Teszt'},
        //         {number: 'AL', quantity: 3, comment: 'Teszt'},
        //         {number: 'DZ', quantity: 1, comment: 'Teszt'}
        //     ],
        //     date: new Date(),
        //     id: 12345,
        //     name: 'Teszt Teszt',
        //     zip: '1234',
        //     city: 'Teszt',
        //     address: 'Teszt utca 12.',
        //     email: 'teszt@teszt.hu',
        // };
        vm.modal = modal;

        function initPage() {

        }

        function addNumber() {
            vm.data.number.push({number: null, quantity: null, comment: null});
        }

        function delNumber(index) {
            vm.data.number.splice(index, 1);
        }

        function modal(template) {
            $uibModal.open({
                templateUrl: template + '.html',
                controller: 'IndexDialogCtrl',
                controllerAs: 'IndexDialogVm',
                size: 'lg'
            });
        }

    }

})();
